import React from 'react';

import { Button, Surface } from '@infoods/lifebase-ui';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import classes from './ExplanationSetupSteps.module.scss';
import bgMealPlanImg from '../../../assets/image/bg-meal-paln.webp';

type ExplanationSetupStepsProps = {
  onStart: () => void;
};

const ExplanationSetupSteps = ({ onStart }: ExplanationSetupStepsProps) => {
  const setupTodo = [
    'Tell us about yourself and your goals',
    'Choose your nutrition coach',
    'Select payment plan',
  ];

  return (
    <div>
      <h1 className={classes.title}>Welcome to SWYMO Nutrition</h1>
      <Surface className={classes.todoContainer}>
        <h5 className={classes.todoTitle}>In the next step, you will:</h5>
        <div className={classes.imgBox}>
          <img src={bgMealPlanImg} alt="macro-bg" />
          <p className={classes.description}>
            <span>Build healthy habits by tracking</span>
            <span className={classes.primaryText}>what you eat every day</span>
            <span className={classes.line} />
          </p>
        </div>
        <ul className={classes.todoBox}>
          {setupTodo.map((todo) => (
            <li className={classes.todoItem} key={todo}>
              <CheckCircleRoundedIcon color="success" />
              <span>{todo}</span>
            </li>
          ))}
        </ul>
      </Surface>
      <div className={classes.buttonRow}>
        <Button variant="contained" size="large" onClick={onStart}>
          Click Here to Get Started!
        </Button>
      </div>
    </div>
  );
};

export { ExplanationSetupSteps };
